import { CountCellProps } from '../../types';
import { formatNumberWithComma } from 'utils';

const TotalPersistingCountsCell = ({
  _customRowProps,
  data: { totalPersisting },
}: CountCellProps) => {
  return <div>{formatNumberWithComma(+totalPersisting)}</div>;
};

export default TotalPersistingCountsCell;
